import { Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 *
 * @returns a guiding text giving information about the json node selection
 */
const JsonEditorGuide = () => {
  return (
    <Tooltip
      title="Browse the data and choose what to display as a table by clicking tick icon. Tables can be created from objects, list of objects, key-value pair, simple list of same element types. Highly nested or mixed data may not display correctly. You can preview the table by clicking eye icon."
      placement="bottom-start"
      arrow
      slotProps={{
        tooltip: {
          className: 'tooltip-font',
        },
      }}
    >
      <IconButton size="small" sx={{ color: 'text.secondary' }}>
        <InfoOutlinedIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default JsonEditorGuide;
